import { type FC, type ReactNode, useContext } from "react";
import { LayerContentContext } from "@onshopfront/components";

interface Props {
    zIndex: number;
    children?: ReactNode;
}

export const UILayerConsumer: FC<Props> = ({ zIndex, children }) => {
    const layer = useContext(LayerContentContext);

    return (
        <LayerContentContext.Provider
            value={{
                ...layer,
                zIndex: zIndex,
            }}
        >
            {children}
        </LayerContentContext.Provider>
    );
};
